import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './PaymentsCreditCard.module.css';
import LayoutDefault from '../../Components/LayoutDefault/LayoutDefault';
import LoadingIndicator from '../../Components/LoadingIndicator/LoadingIndicator';
import PhoneInput from "react-phone-input-2";
import ExecuteAxios from '../../Components/ExecuteAxios/ExecuteAxios';
import { AuthContext } from '../../Contexts/auth';

const CARD_BRANDS = [
    { name: 'Elo', label: 'Elo', regex: /^((636368)|(438935)|(504175)|(451416)|(636297)|(5067)|(4576)|(4011))/, length: 16 },
    { name: 'Visa', label: 'Visa', regex: /^4/, length: 16 },
    { name: 'Mastercard', label: 'Mastercard', regex: /^5[1-5]/, length: 16 },
    { name: 'Amex', label: 'American Express', regex: /^3[47]/, length: 15 },
    { name: 'Diners', label: 'Diners Club', regex: /^3(?:0[0-5]|[68])/, length: 14 },
    { name: 'Discover', label: 'Discover', regex: /^6(?:011|5)/, length: 16 },
    { name: 'Hipercard', label: 'Hipercard', regex: /^(606282|3841)/, length: 16 },
];

function detectCardBrand(digits) {
    if (!digits) return null;
    return CARD_BRANDS.find((brand) => brand.regex.test(digits)) || null;
}

function isValidCardNumber(digits) {
    if (digits.length < 12) return false;

    let sum = 0;
    let shouldDouble = false;

    for (let i = digits.length - 1; i >= 0; i--) {
        let digit = parseInt(digits[i], 10);

        if (shouldDouble) {
            digit *= 2;
            if (digit > 9) digit -= 9;
        }

        sum += digit;
        shouldDouble = !shouldDouble;
    }

    return sum % 10 === 0;
}

function CardBrandIcon({ brand }) {
    switch (brand) {
        case 'Visa':
            return (
                <svg viewBox="0 0 48 30" width="32" height="20" role="img" aria-label="Visa">
                    <text x="24" y="20" textAnchor="middle" fontFamily="Arial, sans-serif" fontStyle="italic" fontWeight="bold" fontSize="13" fill="#fff">VISA</text>
                </svg>
            );
        case 'Mastercard':
            return (
                <svg viewBox="0 0 48 30" width="32" height="20" role="img" aria-label="Mastercard">
                    <circle cx="20" cy="15" r="9" fill="#eb001b" />
                    <circle cx="28" cy="15" r="9" fill="#f79e1b" fillOpacity="0.85" />
                </svg>
            );
        case 'Amex':
            return (
                <svg viewBox="0 0 48 30" width="32" height="20" role="img" aria-label="American Express">
                    <text x="24" y="19" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="10" fill="#fff">AMEX</text>
                </svg>
            );
        case 'Elo':
            return (
                <svg viewBox="0 0 48 30" width="32" height="20" role="img" aria-label="Elo">
                    <text x="24" y="20" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="13" fill="#ffce00">elo</text>
                </svg>
            );
        case 'Diners':
            return (
                <svg viewBox="0 0 48 30" width="32" height="20" role="img" aria-label="Diners Club">
                    <circle cx="24" cy="15" r="9" fill="#fff" />
                    <path d="M24 6a9 9 0 000 18V6z" fill="#0079be" />
                </svg>
            );
        case 'Discover':
            return (
                <svg viewBox="0 0 48 30" width="32" height="20" role="img" aria-label="Discover">
                    <text x="19" y="19" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="7" fill="#fff">DISCOVER</text>
                    <circle cx="40" cy="22" r="7" fill="#f68121" />
                </svg>
            );
        case 'Hipercard':
            return (
                <svg viewBox="0 0 48 30" width="32" height="20" role="img" aria-label="Hipercard">
                    <text x="24" y="19" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="bold" fontStyle="italic" fontSize="10" fill="#fff">hiper</text>
                </svg>
            );
        default:
            return null;
    }
}

function PaymentsCreditCard() {
    const navigate = useNavigate();
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [country, setCountry] = useState("");
    const { clientSelected } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);

    /* const [holderName, setHolderName] = useState("");
     const [number, setNumber] = useState("");
     const [expiryMonth, setExpiryMonth] = useState("");
     const [expiryYear, setExpiryYear] = useState("");
     const [ccv, setCcv] = useState("");
     const [holderCpfCnpj, setHolderCpfCnpj] = useState("");
     const [holderEmail, setHolderEmail] = useState("");
     const [holderPhone, setHolderPhone] = useState("");
     const [postalCode, setPostalCode] = useState("");
     const [addressNumber, setAddressNumber] = useState("");
     const [city, setCity] = useState("");
     const [neighborhood, setNeighborhood] = useState("");
     const [numberComplement, setNumberComplement] = useState("");
     const [agreedToTerms, setAgreedToTerms] = useState(false);*/

    const [holderName, setHolderName] = useState("José Leonardo Perich");
    const [number, setNumber] = useState("4111111111111111");
    const [expiryMonth, setExpiryMonth] = useState("12");
    const [expiryYear, setExpiryYear] = useState("2030");
    const [ccv, setCcv] = useState("123");
    const [holderCpfCnpj, setHolderCpfCnpj] = useState("105.046.349-84");
    const [holderEmail, setHolderEmail] = useState("jose.perich@email.com");
    const [holderPhone, setHolderPhone] = useState("5547999999999");
    const [postalCode, setPostalCode] = useState("89010000");
    const [addressNumber, setAddressNumber] = useState("123");
    const [city, setCity] = useState("Blumenau");
    const [neighborhood, setNeighborhood] = useState("Centro");
    const [numberComplement, setNumberComplement] = useState("Apto 101");
    const [agreedToTerms, setAgreedToTerms] = useState(true);

    useEffect(() => {
        const storedPlan = localStorage.getItem('selectedPlan');

        if (!storedPlan) {
            navigate('/plans');
            return;
        }

        setSelectedPlan(JSON.parse(storedPlan));
    }, [navigate]);


    if (!selectedPlan) return null;

    const cardDigits = number.replace(/\D/g, '');
    const cardBrand = detectCardBrand(cardDigits);
    const cardExpectedLength = cardBrand ? cardBrand.length : 16;
    const cardNumberComplete = cardDigits.length >= cardExpectedLength;
    const cardNumberValid = !cardNumberComplete || isValidCardNumber(cardDigits);
    const showCardNumberError = cardNumberComplete && !cardNumberValid;

    const isFormValid =
        holderCpfCnpj.trim() !== "" &&
        holderEmail.trim() !== "" &&
        holderPhone.trim() !== "" &&
        postalCode.trim() !== "" &&
        city.trim() !== "" &&
        neighborhood.trim() !== "" &&
        addressNumber.trim() !== "" &&
        holderName.trim() !== "" &&
        cardNumberComplete &&
        cardNumberValid &&
        expiryMonth.trim() !== "" &&
        expiryYear.trim() !== "" &&
        ccv.trim() !== "" &&
        agreedToTerms;

    const handleCheckout = async () => {
        if (!selectedPlan || !isFormValid) return;

        try {
            const payload = {
                clientId: clientSelected,
                holderName,
                number: number.replace(/\s/g, ''), // remove espaços do cartão
                expiryMonth,
                expiryYear,
                ccv,
                holderCpfCnpj,
                holderEmail,
                holderPhone,
                postalCode,
                addressNumber,
                numberComplement,
                planCode: selectedPlan.code,
                remoteIp: window.location.hostname
            };

            try {
                setLoading(true)
                const loaderSafeDisable = () => {
                    setTimeout(() => {
                        if (loading) {
                            setLoading(false)
                        }
                    }, 30000);
                }
                loaderSafeDisable()
                const response = await ExecuteAxios.api('post', '/payment/create-payment-subscription/', payload,
                    {
                        params: {
                            payload
                        }
                    });
                navigate('/plans')
            } catch (error) {
                setLoading(false)
            }
        } catch (error) {
            console.error('Erro ao criar assinatura:', error);

            alert(
                error?.response?.data?.message ||
                'Erro ao processar pagamento. Tente novamente.'
            );
        }
    };

    function maskCpfCnpj(value) {
        const digits = value.replace(/\D/g, '').slice(0, 14);

        if (digits.length <= 11) {
            // CPF
            return digits
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        }

        // CNPJ
        return digits
            .replace(/(\d{2})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1/$2')
            .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
    }

    function maskCep(value) {
        return value
            .replace(/\D/g, '')   // só números
            .slice(0, 8)          // limite 8 dígitos
            .replace(/(\d{5})(\d)/, '$1-$2'); // 00000-000
    }

    function maskCardNumber(value) {
        const rawDigits = value.replace(/\D/g, '');
        const brand = detectCardBrand(rawDigits);
        const maxLength = brand ? brand.length : 16;

        return rawDigits
            .slice(0, maxLength)
            .replace(/(\d{4})(?=\d)/g, '$1 ');
    }

    function maskMonth(value) {
        let v = value.replace(/\D/g, '').slice(0, 2);

        if (v.length === 2) {
            const num = parseInt(v);
            if (num < 1) v = '01';
            if (num > 12) v = '12';
        }

        return v;
    }

    function maskYear(value) {
        return value.replace(/\D/g, '').slice(0, 4);
    }

    function maskCCV(value) {
        return value.replace(/\D/g, '').slice(0, 4);
    }

    function preventAutofill(e) {
        e.target.removeAttribute('readonly');
    }

    return (
        <LayoutDefault customMainClass={styles.mainAlternative}>
            <div className={styles.containerCheckout}>
                <div className={styles.paymentBox}>
                    <LoadingIndicator loaded={!loading} >

                        {/* PLANO RESUMO */}
                        <div className={styles.planResume}>
                            Você está contratando o <strong>{selectedPlan.name + ' '}</strong>
                            <span>R${selectedPlan.totalPrice}/mês</span>
                        </div>

                        <div className={styles.dataPayment}>


                            <div className={styles.planResumeItens}>
                                {/* DADOS PESSOAIS */}
                                <div className={styles.section}>
                                    <h3>Dados pessoais</h3>
                                    <div className={styles.row}>
                                        <div className={styles.field}>
                                            <label style={{ color: '#7e7575' }}>CPF/CNPJ</label>
                                            <input
                                                value={holderCpfCnpj}
                                                placeholder="000.000.000-00"
                                                onChange={(e) => setHolderCpfCnpj(maskCpfCnpj(e.target.value))}
                                                required
                                                style={{ color: '#7e7575' }}
                                            />
                                        </div>

                                        <div className={styles.field}>
                                            <label>Email</label>
                                            <input
                                                type="email"
                                                value={holderEmail}
                                                onChange={(e) => setHolderEmail(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* ENDEREÇO */}
                                <div className={styles.section}>
                                    <h3>Endereço de cobrança</h3>

                                    <div className={styles.row}>
                                        <div className={`${styles.field} ${styles.fieldWide}`}>
                                            <label style={{ color: '#7e7575' }}>Celular</label>
                                            <PhoneInput
                                                value={holderPhone}
                                                country={'br'}
                                                onFocus={() => {
                                                    if (!holderPhone && country === 'br') {
                                                        setHolderPhone('+55');
                                                    }
                                                }}
                                                onChange={(val) => setHolderPhone(val)}
                                                inputStyle={{ width: '100%', height: '34px' }}
                                                enableSearch
                                                placeholder={'(99) 99999-9999'}
                                                masks={{ br: '(..) .....-....' }}
                                                localization={{
                                                    br: 'Brasil',
                                                    us: 'Estados Unidos',
                                                    gb: 'Reino Unido',
                                                    fr: 'França',
                                                    de: 'Alemanha',
                                                    search: 'Buscar',
                                                }}
                                            />
                                        </div>

                                        <div className={styles.field}>
                                            <label>CEP</label>
                                            <input value={postalCode} onChange={e => setPostalCode(maskCep(e.target.value))}
                                                placeholder="00000-000" required />
                                        </div>

                                        <div className={styles.field}>
                                            <label>Cidade</label>
                                            <input value={city} onChange={e => setCity(e.target.value)} required />
                                        </div>

                                        <div className={styles.field}>
                                            <label>Bairro</label>
                                            <input value={neighborhood} onChange={e => setNeighborhood(e.target.value)} required />
                                        </div>

                                        <div className={styles.field}>
                                            <label>Número</label>
                                            <input value={addressNumber} onChange={e => setAddressNumber(e.target.value)} required />
                                        </div>

                                        <div className={styles.field}>
                                            <label>Complemento</label>
                                            <input value={numberComplement} onChange={e => setNumberComplement(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.planResumeItens}>

                                <div className={styles.section}>
                                    <h3>Dados do cartão</h3>

                                    <div className={styles.row}>
                                        <div className={styles.field}>
                                            <label>Nome no cartão</label>
                                            <input
                                                value={holderName}
                                                onChange={e => setHolderName(e.target.value)}
                                                required
                                                autoComplete="off"
                                                readOnly
                                                onFocus={preventAutofill}
                                            />
                                        </div>

                                        <div className={styles.field}>
                                            <label>Número do cartão</label>
                                            <div className={styles.cardNumberWrapper}>
                                                <input
                                                    placeholder="0000 0000 0000 0000"
                                                    value={number}
                                                    onChange={e => setNumber(maskCardNumber(e.target.value))}
                                                    required
                                                    autoComplete="off"
                                                    readOnly
                                                    onFocus={preventAutofill}
                                                    className={showCardNumberError ? styles.inputError : ''}
                                                />
                                                {cardBrand && (
                                                    <span className={styles.cardBrandBadge} title={cardBrand.label}>
                                                        <CardBrandIcon brand={cardBrand.name} />
                                                    </span>
                                                )}
                                            </div>
                                            {showCardNumberError && (
                                                <span className={styles.fieldError}>Número de cartão inválido</span>
                                            )}
                                        </div>
                                    </div>

                                    <div className={styles.row}>
                                        <div className={styles.field}>
                                            <label>Mês</label>
                                            <input
                                                placeholder="MM"
                                                value={expiryMonth}
                                                onChange={e => setExpiryMonth(maskMonth(e.target.value))}
                                                required
                                                autoComplete="off"
                                                readOnly
                                                onFocus={preventAutofill}
                                            />
                                        </div>

                                        <div className={styles.field}>
                                            <label>Ano</label>
                                            <input
                                                placeholder="AAAA"
                                                value={expiryYear}
                                                onChange={e => setExpiryYear(maskYear(e.target.value))}
                                                required
                                                autoComplete="off"
                                                readOnly
                                                onFocus={preventAutofill}
                                            />
                                        </div>

                                        <div className={styles.field}>
                                            <label>CCV</label>
                                            <input
                                                placeholder="000"
                                                value={ccv}
                                                onChange={e => setCcv(maskCCV(e.target.value))}
                                                required
                                                autoComplete="off"
                                                readOnly
                                                onFocus={preventAutofill}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* AÇÃO */}
                                <div className={styles.actionBox}>
                                    <label className={styles.termsCheckbox}>
                                        <input
                                            type="checkbox"
                                            checked={agreedToTerms}
                                            onChange={(e) => setAgreedToTerms(e.target.checked)}
                                            required
                                        />
                                        Você concorda que a Condbot cobrará do seu cartão o valor acima agora
                                        e de forma recorrente mensalmente até que você cancele, de acordo com
                                        os nossos termos de uso.
                                    </label>

                                    <button
                                        className={styles.payButton}
                                        onClick={handleCheckout}
                                        disabled={!isFormValid}
                                    >
                                        <span className={styles.lockIcon}>🔒</span>
                                        Finalizar pagamento com segurança
                                    </button>

                                    <p
                                        className={styles.requiredHint}
                                        style={{ visibility: isFormValid ? 'hidden' : 'visible' }}
                                    >
                                        Preencha todos os campos obrigatórios e aceite os termos para finalizar o pagamento.
                                    </p>

                                    <div className={styles.trustBox}>
                                        <div className={styles.trustRow}>
                                            <span className={styles.trustItem}>🔒 Pagamento seguro</span>
                                            <span className={styles.trustItem}>💳 Visualização de faturas</span>
                                        </div>

                                        <div className={styles.trustRow}>
                                            <span className={styles.trustItem}>✔ Cancele quando quiser</span>
                                            <span className={styles.trustItem}>🧾 Nota fiscal disponível</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </LoadingIndicator>
                </div>
            </div>
        </LayoutDefault >
    );
}

export default PaymentsCreditCard;
